
// Utils

import { preventerTools } from '../tools/preventerTools';

// Constants

import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';

export const extractUserName = environment => {
    
    const {
        impersonationDetails,
        user
    } = environment;
    
    const {
        role
    } = preventerTools.provideObject(user);

    const getUserName = user => {
        const {
            firstName,
            lastName,
            nameSuffix
        } = user;

        return nameSuffix ?
            `${firstName} ${lastName} ${nameSuffix}` :
            `${firstName} ${lastName}`;
    };

    return role === ALL_USER_ROLES.INDIVIDUAL ? user && getUserName(user) : impersonationDetails && impersonationDetails.name;
};